import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { API } from '@/utils/api';
import { fmtH } from '../agendaUtils';

export const FreeHours = ({ date, duration, value, onPick, excludeId = '' }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!date || !duration) return;
    let alive = true;
    setData(null);
    axios.get(`${API}/agenda/free-slots`, { params: { date, duration_min: duration, exclude_id: excludeId } })
      .then(r => { if (alive) setData(r.data); }).catch(() => { if (alive) setData({ slots: [], error: true }); });
    return () => { alive = false; };
  }, [date, duration, excludeId]);

  if (!data) return <div className="flex items-center gap-2 text-sm text-slate-500" data-testid="free-hours-loading"><Loader2 className="w-4 h-4 animate-spin" />Recherche des heures libres…</div>;
  if (data.error) return <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="free-hours-error">Impossible de charger les heures libres, réessayez.</p>;
  const free = data.slots.filter(s => s.ok);
  if (data.closed) return <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="free-hours-closed">Le garage est fermé ce jour-là.</p>;
  if (!free.length) return <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="free-hours-none">Aucune heure libre ce jour pour cette durée.</p>;

  return (
    <div className="flex flex-wrap gap-1.5" data-testid="free-hours-list">
      {free.map(s => (
        <button key={s.time} type="button" onClick={() => onPick(s.time)} data-testid={`free-hour-${s.time.replace(':', '')}`}
          title={`Fin à ${fmtH(s.end_time)}${s.end_date !== date ? ' (jour suivant)' : ''}`}
          className={`px-3 py-1.5 rounded-lg text-sm font-semibold border transition-colors ${value === s.time ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white border-emerald-300 text-emerald-800 hover:bg-emerald-50'}`}>
          {fmtH(s.time)}
        </button>
      ))}
    </div>
  );
};
